import loadBlock from './load-block';
import './load-vendors';
import adminInitializeBlock from './admin-initialize-block';

app.loadBlock = loadBlock;
app.adminInitializeBlock = adminInitializeBlock;

